<template>
    <div class="search_detail">
        <form action="/">
        <van-search
        v-model="keywords"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        >
        <template #action>
            <div @click="onSearch">搜索</div>
        </template>
        </van-search>
        </form>
		<div class="history block">
			<div v-for="(item,index) in historyWords" :key="index" @click="clickKeyWord(item)" class="history-item">
                <div class="name">
                    <van-icon name="clock-o" />
                    <span>{{item}}</span>
                </div>
                <van-icon name="cross" />
			</div>
		</div>
        <van-tabs v-model="active" color="#901d22" v-if="!nullData">
            <van-tab title="综合" >
                <div>
                    <!-- 专家 -->
                    <div class="wrap" v-if="expertList.length>0">
                        <h1>专家</h1>
                        <div >
                            <template v-for="(item,index) in expertList" v-show="index<=2">
                                <expert-info :expertInfo="item" :key="item.id"></expert-info>
                            </template>
                        </div>
                        <div class="more">
                            <a href="javascript:voild(0)" @click="skipTab(4)">
                                <span>查看更多专家</span>
                                <van-icon name="arrow" />
                            </a>
                        </div>
                    </div>
                    <div class="gray-10" v-if="expertList.length>0"></div>
                    <!-- 专栏  -->
                    <div class="wrap" v-if="columnList.length>0">
                        <h1>专栏</h1>
                        <div class="columnList">
                            <div class="columnItemBlock" v-for="(item,index) in columnList" :key="item.id" v-show="index<=0">
                                <div class="item">
                                    <div class="imgWrap">
                                        <img :src="item.banner" alt="">                                
                                    </div>
                                    <div class="info">
                                        <span class="name line-clamp-3">{{item.name}}</span> 
                                        <!-- <span class="number">2 关注</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="more">
                            <a href="javascript:voild(0)" @click="skipTab(3)">
                                <span>查看更多专栏</span>
                                <van-icon name="arrow" />
                            </a>
                        </div>
                    </div>
                    <div class="gray-10" v-if="columnList.length>0"></div>
                    <!-- 文章  -->
                    <div class="wrap" v-if="articleList.length>0">
                        <h1>文章</h1>
                        <div>
                            <template v-for="(item,index) in articleList" v-show="index<=2">
                                <item-block :itemContent="item" :searchType="3" :key="item.id"></item-block>
                            </template>
                        </div>
                        <div class="more">
                            <a href="javascript:voild(0)" @click="skipTab(1)">
                                <span>查看更多文章</span>
                                <van-icon name="arrow" />
                            </a>
                        </div>
                    </div>
                    <div class="gray-10" v-if="articleList.length>0"></div>
                    <!-- 会议  -->
                    <div class="wrap" v-if="meetingList.length>0">
                        <h1>会议</h1>
                        <template v-for="(item,index) in meetingList" v-show="index<=2">
                            <item-block :itemContent="item" :searchType="0" :key="item.id"></item-block>
                        </template>
                        <div class="more">
                            <a href="javascript:voild(0)" @click="skipTab(2)">
                                <span>查看更多会议</span>
                                <van-icon name="arrow" />
                            </a>
                        </div>
                    </div>
                </div>
                <p class="noData" v-if="expertList.length==0&&columnList.length==0&&articleList.length==0&&meetingList.length==0">
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
            <van-tab title="文章">
                <div class="wrap" v-if="articleList.length>0">
                    <template v-for="(item) in articleList">
                        <item-block :itemContent="item" :searchType="3" :key="item.id"></item-block>
                    </template>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
            <van-tab title="会议">
                <div class="wrap" v-if="meetingList.length>0">
                    <template v-for="(item) in meetingList">
                         <item-block :itemContent="item" :searchType="0" :key="item.id"></item-block>
                    </template>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
            <van-tab title="专栏">
                <div class="wrap" v-if="columnList.length>0">
                    <div class="columnList">
                        <div class="columnItemBlock" v-for="(item) in columnList" :key="item.id" >
                            <div class="item">
                                <div class="imgWrap">
                                    <img :src="item.banner" alt="">                                
                                </div>
                                <div class="info">
                                    <span class="name line-clamp-3">{{item.name}}</span> 
                                    <!-- <span class="number">2 关注</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
            <van-tab title="专家">
                <div class="wrap" v-if="expertList.length>0">
                    <template v-for="(item) in expertList">
                        <expert-info :expertInfo="item" :key="item.id"></expert-info>
                    </template>
                </div>
                <p class="noData" v-else>
                    暂无“<span>{{keywords}}</span>”相关搜索结果
                </p>
            </van-tab>
        </van-tabs>   
        <van-empty image="search" description="暂无任何数据" v-else/> 
    </div>
</template>
<script>
import ColumnItemBlock from '../../components/ColumnItemBlock.vue'
import ExpertInfo from '../../components/Expert/ExpertInfo.vue'
import ItemBlock from '../../components/ItemBlock.vue';
import {IndexSearch} from '@/config/interface.js';

export default {
    components:{
        ExpertInfo,
        ColumnItemBlock,
        ItemBlock

    },
    data(){
        return{
            active:0,
            keywords:'',
            historyWords:[],     //历史搜索
            tabsTitle:null,     
            expertList:[],      //专家
            columnList:[],      //专栏
            meetingList:[],     //会议
            articleList:[],     //文章
            nullData:true,
        }
    },
    mounted(){
        // this.getHistoryWords();
    },
    methods:{
		// //获取输入框里输入的关键词
		// searchInput(){
		// 	this.keywords=(this.keywords).replace(/(^\s*)|(\s*$)/g, '');
		// 	console.log(this.keywords);
		// },
		// //获取本地存储的关键词
		// getHistoryWords(){
		// 	let historyWords=localStorage.getItem('historyWords');
		// 	if(historyWords){
		// 		this.historyWords=JSON.parse(historyWords);
		// 	}else{
		// 		this.historyWords=[];
		// 	}
        // },
		// //点击搜索的标签
		// clickKeyWord(word){
		// 	this.keywords=word;
		// 	this.onSearch();
		// },
        //搜索
        onSearch(){
            if(this.keywords!=''){
                const url=IndexSearch;
                const method='POST';
                let params={
                    keyword:this.keywords
                }
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        this.tabsTitle=data.head;
                        console.log(this.tabsTitle)
                        this.expertList=data.result['专家'];
                        this.columnList=data.result['专栏'];
                        this.meetingList=[];
                        data.result['会议'].forEach((item,index)=>{
                                item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
                                let end_at_arr=(item.end_at.split(' ')[0]).split('-');
                                item.end_at=end_at_arr[1]+'.'+end_at_arr[2];
                                this.meetingList.push(item);
                            })
                        this.articleList=data.result['文章'];
                        this.nullData=this.expertList.length==0&&this.columnList.length==0&&this.meetingList.length==0&&this.articleList.length==0?true:false;
                    }else if(res.code==401){
                        this.expertList=[];
                        this.columnList=[];
                        this.meetingList=[];
                        this.articleList=[];
                        this.nullData=true;
                        }
                })
            }else{
                this.nullData=true;
            }

        },
        //取消
        onCancel(){
            // this.keywords='';
            // this.onSearch();
        },
        //跳转tab
        skipTab(active){
            this.active=active;
        }
    }
}
</script>
<style lang="scss" scoped>
    .search_detail{
        .gray-10{
            width:100%;
            height:10px;
            background-color:#efefef;
        }
        .history{
            padding:0 14px 10px;
            .history-item{
                display:flex;
                padding:8px 0;
                justify-content: space-between;
                align-items: center;
                border-bottom:1px solid #ddd;
                .name{
                    font-size:15px;
                    color:#666;
                    display:flex;
                    align-items: center;
                    i{
                        margin-right:5px;
                    }
                }
            }
            >.history-item:last-child{border:0px};
        }
        .noData{
            text-align: center;
            font-size:17px;
            letter-spacing: 1px;
            margin-top:15px;
            span{
                color:#901d22;
            }
        }
        .wrap{
            padding:14px 14px 0;
            h1{
                font-size:16px;
                font-weight: normal;
                color:#999;
            }
            .more{
                text-align: right;
                padding:10px 0;
                a{
                    display: inline-block;
                    font-size:15px;
                    color:#666;
                    i{
                        display: inline-block;
                        vertical-align: -2px;
                    }
                }
            }
        }
        .columnList{
            padding:10px 0 0;
            .columnItemBlock{
                border-bottom: 0.1px solid #ddd;
                .item{
                    width:100%;
                    .imgWrap{
                        width:100%;
                        padding-bottom: 56%;
                        position: relative;
                        img{
                            position: absolute;
                            top:0px;
                            left:0px;
                            width:100%;
                            height:100%;
                        }
                    }
                    .info{
                        padding:10px 0;
                        .name{
                            font-size:15px;
                            font-weight:bold;
                        }
                        .number{color:#999}
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/Search/details.vue